module.exports = __webpack_public_path__ + "img/ywyk-instructions03.89b84e2d.jpg";